import React from 'react';
import cx from 'classnames';
import { CheckboxField } from '@zola/zola-ui/src/components/Form/CheckboxField';
import styles from './styles.module.less';

export type LayoutHeaderProps = {
  children?: React.ReactNode;
};

export type LayoutCheckboxProps = {
  className?: string;
  id?: string;
  disabled?: boolean;
  label: string;
  checked?: boolean;
  onChange: (checked: boolean) => void;
};

export const Checkbox = ({
  className,
  id,
  disabled,
  label,
  checked,
  onChange,
}: LayoutCheckboxProps): JSX.Element => {
  return (
    <CheckboxField
      className={cx(styles.checkbox, className)}
      id={id}
      label={label}
      disabled={disabled}
      checked={checked}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.checked)}
    />
  );
};

export default Checkbox;
